import React, { useState, useMemo } from "react";
import {
  FormControl,
  Select,
  MenuItem,
  ListSubheader,
  TextField,
  InputAdornment
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import "./components.css";

const DropdownComponent = (props) => {
  const { value, onChange, options, questionKey, disabled } = props;
  const [searchText, setSearchText] = useState("");

  const containsText = (text, searchText) => {
    if (typeof text !== 'string') return false;
    return text.toLowerCase().includes(searchText.toLowerCase());
  };

  const displayedOptions = useMemo(
    () => options?.filter((option) => option.text && containsText(option.text, searchText)),
    [searchText, options]
  );

  const handleOnChange = (e) => {
    let v = e.target.value === "--Select--" ? "" : e.target.value;
    onChange(questionKey, v);
  };

  const handleMenuItemClick = (selectedValue) => {
    if (selectedValue === value) {
      onChange(questionKey, selectedValue);
    }
  };

  const renderSelectedValue = (selected) => {
    if (!selected) {
      return "";
    }
    const selectedOption = options.find(option => option.value === selected);
    return selectedOption ? selectedOption.text : "";
  };

  return (
    <div className="flexAlignColumnClassName">
      <FormControl fullWidth variant="outlined" disabled={disabled}>
        <Select
          labelId="search-select-label"
          id="search-select"
          value={value ? value : ""}
          displayEmpty
          onChange={handleOnChange}
          onClose={() => setSearchText("")}
          renderValue={(selected) => renderSelectedValue(selected)}
          MenuProps={{ autoFocus: false }}
          classes={{
            root: "outlinedInputRoot",
            focused: "outlinedInputFocused",
            notchedOutline: "outlinedInput",
          }}
          inputProps={{ 'aria-label': 'Without label' }}
        >
          <ListSubheader>
            <TextField
              size="small"
              placeholder="Type to search..."
              fullWidth
              value={searchText}
              className="textFieldInputComponent"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                classes: {
                  root: "outlinedInputRoot",
                  focused: "outlinedInputFocused",
                  notchedOutline: "outlinedInput",
                },
              }}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={(e) => {
                if (e.key !== "Escape") {
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
          <MenuItem disabled value="" className="menuItemOptionTag">
            -- Select --
          </MenuItem>
          {displayedOptions.map((option) => (
            <MenuItem
              key={option.value}
              value={option.value}
              className="menuItemOptionTag"
              onClick={() => handleMenuItemClick(option.value)}
            >
              {option.text}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

export default DropdownComponent;
